import * as React from "react";

import {xdQAAttribute}                     from "../../analytics-layout";
import {analyticSum, analyticSummaryArray} from "../analytics-locale";
import "./analytics-cities.scss";

const HEIGHT_VIEWBOX = 100
const WIDTH_VIEWBOX = 200
const KEY_ANALYTIC = 'city'
const DISPLAY_MAX = 3

export const AnalyticsCities = ({leadInteractions, colorsFill}) => {
    const viewBox = `0 0 ${WIDTH_VIEWBOX} ${HEIGHT_VIEWBOX}`
    const [hoveredValue, setHoveredValue] = React.useState(null)
    const values = analyticSummaryArray(leadInteractions, KEY_ANALYTIC, 'idLead', KEY_ANALYTIC)
    const sum = analyticSum(values, DISPLAY_MAX)

    return (
        <div className="city-graph-lliv4" >
            <div className="city-legend">
                <h5
                    className="legend-title"
                    {...xdQAAttribute('label', 'city title')}
                >
                    Cities
                </h5>
                <p
                    className="legend-subtitle"
                    {...xdQAAttribute('text', 'citiy subtitle')}
                >
                    {subheaderText(values)
                }</p>
            </div>
            <svg
                className="city"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                viewBox={viewBox}
                {...xdQAAttribute('image', 'city chart')}
            >
                {
                   values.map((value, i) => {
                        return (
                            i < DISPLAY_MAX
                            ?
                                <Arc
                                    key={i}
                                    index={i}
                                    fillColor={colorsFill[i % colorsFill.length]}
                                    value={value}
                                    sum={sum}
                                    setHoveredValue={setHoveredValue}
                                />
                            : null
                        )

                   })
                }
            </svg>
        </div>
    )
}

const subheaderText = (values) => {
    if(!values) {
        return 'No leads found'
    }
    if(values.length === 0) {
        return 'No leads found'
    }
    if(values.length === 1) {
        return 'City with the most leads'
    }

    return 'Cities with the most leads'
}

const createArcPath = (index, angle) => {
    const centerX = Math.floor(2 * WIDTH_VIEWBOX / 3)
    const centerY =  Math.floor(HEIGHT_VIEWBOX / 2)
    const startY = centerY - Math.floor(HEIGHT_VIEWBOX / 2 - (HEIGHT_VIEWBOX / 6) * (index))
    const largeArcFlag = angle > Math.PI ? 1 : 0
    const radius = Math.floor(HEIGHT_VIEWBOX / 2 - (HEIGHT_VIEWBOX / 6) * (index))
    const endX = (centerX + Math.cos(angle - Math.PI / 2) * radius)
    const endY = (centerY + Math.sin(angle - Math.PI / 2) * radius)

    const move = `M ${centerX},${startY} `
    const arc = `A ${radius},${radius} 0 ${largeArcFlag},1 ${endX},${endY}`

    return (move + arc)
}


const Arc = ({index, fillColor, value, sum, setHoveredValue}) => {
    const ref = React.useRef(null)
    const [isHovered, setIsHovered] = React.useState(false)

    const handlePointerEnter = () => {
        setHoveredValue(value.label)
        setIsHovered(true)
    }

    const handlePointerLeave = () => {
        setHoveredValue(null)
        setIsHovered(false)
    }

    const cityNameFormatted = (name) => {
        const nameMax = 18
        if(name.length < nameMax) {
            return name
        }
        return `${name.substring(0, nameMax)}... `
    }

    const offsetCount = (count) => {
        const offsetBase = -8
        const offsetCharacter = -5
        const orderOfMagnitude = count.toString().length

        return offsetBase + orderOfMagnitude * offsetCharacter
    }

    const centerX = Math.floor(2 * WIDTH_VIEWBOX / 3)
    const centerY =  Math.floor(HEIGHT_VIEWBOX / 2)
    const startY = centerY - Math.floor(HEIGHT_VIEWBOX / 2 - (HEIGHT_VIEWBOX / 6) * (index))

    const angleFull = 3 * Math.PI / 2
    const angleValue = angleFull * value.count / sum
    const pathFull = createArcPath(index, angleFull)
    const translucent = "#FFFFFF00"
    const colorBackground = "#33415020"
    const colorCount = "#249AF3"
    const colorHover = "#249AF320"
    const colorText =  "#33415080"
    const fontSize = 9
    const heightOverlay = 13
    const offsetXOverlay = -130
    const offsetXCityText = -126
    const offsetYOverlay = -6
    const offsetYText = 3.5
    const strokeWidth = 10
    const widthOverlay = 127

    const cityName = cityNameFormatted(value.label)
    const cityCount = value.count

    return (
        <>
            <path
                className="arc background"
                d={pathFull}
                fill="none"
                stroke={colorBackground}
                strokeWidth={strokeWidth}
            />
            <path
                className="arc value"
                d={createArcPath(index, angleValue)}
                fill="none"
                stroke={fillColor}
                strokeWidth={strokeWidth}
                {...xdQAAttribute('image', 'city arc')}
            />
            <path
                className="arc hover"
                ref={ref}
                d={pathFull}
                fill="none"
                onPointerEnter={handlePointerEnter}
                onPointerLeave={handlePointerLeave}
                stroke={translucent}
                strokeWidth={strokeWidth}
            />
            <rect
                x={centerX + offsetXOverlay}
                y={startY + offsetYOverlay}
                width={widthOverlay}
                height={heightOverlay}
                rx="2"
                fill={`${isHovered ? colorHover : translucent}`}
                style={{
                    transition: 'all 0.4s ease-in-out 0.2s'
                }}
            />
            <text
                className={`${isHovered ? 'hovered ' : ''} city-text`}
                x={centerX + offsetXCityText}
                y={startY + offsetYText}
                fill={colorText}
                fontSize={fontSize}
                fontWeight={'normal'}
                style={{
                    transition: 'all 0.4s ease-in-out 0.2s'
                }}
                {...xdQAAttribute('text', cityName)}
            >
                {cityName}
            </text>
            <text
                className={`${isHovered ? 'hovered ' : ''} city-text`}
                x={centerX + offsetCount(cityCount)}
                y={startY + offsetYText}
                fill={colorCount}
                fontSize={fontSize}
                fontWeight={'normal'}
                style={{
                    transition: 'all 0.4s ease-in-out 0.2s'
                }}
                {...xdQAAttribute('text', `count ${cityName}`)}
            >
                {cityCount}
            </text>
        </>
    )
}